// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"36a16938","281":"957bdb53","453":"d6490e85","487":"9d9c9c78","731":"c57bd664","765":"871c1839","948":"45cf0795"}[chunkId] + ".chunk.js";
};